import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const AnimatedNumber = ({ end, suffix = '', prefix = '', decimals = 0, duration = 2.4 }) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  return (
    <span ref={ref}>
      {inView ? (
        <CountUp
          end={end}
          duration={duration}
          separator="."
          decimal=","
          decimals={decimals}
          prefix={prefix}
          suffix={suffix}
          enableScrollSpy={false}
        />
      ) : (
        `${prefix}0${suffix}`
      )}
    </span>
  );
};

export default AnimatedNumber;
